import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, NgZone, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';
import { ConfirmationModalService } from 'src/app/services/confirmation-modal.service';
import { DataSharingService } from 'src/app/services/data-sharing.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { PersonalDataState, PersonalDataStateModel } from 'src/app/state/personal-data.state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-new',
  standalone: true,
  imports: [
    CommonModule,
    NgbNavModule,
    NgbDropdownModule,
  ],
  templateUrl: './header-new.component.html',
  styleUrl: './header-new.component.scss'
})
export class HeaderNewComponent implements OnInit {
  isLoginRequired: any;
  toggle: boolean | undefined;
  firstName: any;
  lastName: any;
  changeDetection: any;
  disposer: string;
  formName: string | null | undefined;
  inApp: any;
  isAuthenticated: boolean | undefined;
 @Select(PersonalDataState)
  getPersonalData$!: Observable<PersonalDataStateModel>;
  isExpired: boolean | undefined;
  isExistingFlow: boolean = false ;

   constructor(
    private zone: NgZone,
    private renderer: Renderer2,
    private modalSvc: ConfirmationModalService,
    private cd: ChangeDetectorRef,
    private readonly keycloak: KeycloakService,
    private sessionStorage: SessionStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store,
    private keycloakSvc: KeycloakService,
        private dataSharingSvc: DataSharingService,
    private kc: KeycloakService,
  ) {
    // this.formName = this.sessionStorage.getFormName();
    this.renderer.listen('window', 'click', (eve: Event) => {
      const target = eve.target as HTMLElement;
      if (
        !target.classList.contains('user-label') &&
        !target.classList.contains('logoutoption') &&
        !target.classList.contains('logout-collapsible') &&
        !target.classList.contains('popuplogout') &&
        !target.classList.contains('custombtn')
      ) {
        this.toggle = false;
      }
    });

    this.firstName = this.sessionStorage.getFirstname()
    this.lastName = this.sessionStorage.getLastname()
    this.disposer = this.sessionStorage.getDisposer() as string;

  }
  async ngOnInit() {
     if (this.keycloakSvc.isLoggedIn()) {
      this.fetchToken();
         this.dataSharingSvc.getFirstName().subscribe({
            next: (value) => {
              this.firstName = value;
            },
         });
       this.dataSharingSvc.getLastName().subscribe({
         next: (value) => {
           this.lastName = value;
         },
       });

      //    this.disposer = this.sessionStorage.getDisposer() as string;
      //  if (!this.firstName && !this.lastName) {
      //    this.getPersonalData$.subscribe({
      //      next: (value) => {
      //        this.firstName = value?.firstName ? value?.firstName : this.sessionStorage.getFirstname();
      //        this.lastName = value?.lastName ? value?.lastName : this.sessionStorage.getLastname();
      //      },
      //      error: (err) => {
      //        this.lastName = this.sessionStorage.getLastname();
      //        this.firstName = this.sessionStorage.getFirstname();
      //      },
      //    });
      //  }

    }
    //  else if (window.location.href.includes('existing') && this.kc.isLoggedIn() && this.isAuthenticated && !this.disposer){
    //    this.fetchToken();
    //    if (!this.firstName) {
    //      this.getPersonalData$.subscribe({
    //        next: (value) => {
    //          this.firstName = value?.firstName ? value?.firstName : this.sessionStorage.getFirstname();
    //          this.lastName = value?.lastName ? value?.lastName : this.sessionStorage.getLastname();
    //        },
    //        error: (err) => {
    //          this.lastName = this.sessionStorage.getLastname();
    //          this.firstName = this.sessionStorage.getFirstname();
    //        },
    //      });
    //    }
    // }
    else{
       this.firstName = this.dataSharingSvc.getFirstName();
       this.lastName = this.dataSharingSvc.getLastName();
    }
    this.isExpired = this.sessionStorage.getExpireValue() === 'true';
  }

  ngAfterViewInit() {
    this.inApp = this.activatedRoute.snapshot.queryParamMap.get('inApp');
    this.disposer = this.sessionStorage.getDisposer() as string;

    this.cd.detectChanges();
  }

  async fetchToken() {
    const token = await this.keycloakSvc.getToken();
    const tokenData = JSON.parse(atob(token.split('.')[1]));
    //console.log('tokenData', tokenData);
  // if (tokenData && this.checkEntity(tokenData)) {
  //     await this.keycloakSvc.logout(window.location.origin);
  //   }
   // this.sessionStorage.storeDisposer(tokenData['x-bawag'].disposer_number);
    // this.sessionStorage.storePersonalDetails(
    //   tokenData['given_name'].first_name,
    //   tokenData['family_name'].last_name,
    // )
     this.sessionStorage.storePersonalDetails(
      tokenData['given_name'],
      tokenData['family_name']
     )
    // console.log('firstName', this.sessionStorage.getFirstname());
    //  console.log('lastName', this.sessionStorage.getLastname());

        this.firstName = this.sessionStorage.getFirstname();
       this.lastName = this.sessionStorage.getLastname();
  }


  // private checkEntity(tokenData: any): boolean {
  //   return !themeParameters.validEntities.includes(tokenData['x-bawag'].entity);
  // }
  main() {
    return window.location.href.includes('main') || window.location.href.includes('product-overview');
  }

  collapse() {
    this.toggle = !this.toggle;
  }

  isInApp() {
    return this.sessionStorage.getInApp() === 'true';
  }

  homePage() {
   // window.open('https://www.bawag.at', '_blank');
      window.open(environment.account, '_blank');
  }

  showPopup() {
    this.modalSvc.openLogout();
  }

  private invokeExistingCustomer() {
  }

}
